import React, { useRef, useCallback, useState, useEffect } from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { useHistory, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import getValidationErrors from '../../../../utils/getValidationErrors';

import Input from '../../../../components/Input';
import Button from '../../../../components/Button';

import { Container, Content } from '../styles';

import { ResendCode } from './styles';
import { useRouteRules } from '../../../../hooks/routeRules';
import { useAuth } from '../../../../hooks/auth';
import IndividuoService from '../../../../services/IndividuoService';
import { CodeSchema } from '../../../../validations/CodeSchema';

interface FormData {
  verificationCode: string;
}

const ConfirmCodeForgotPassword: React.FC = () => {
  const { verifyRules } = useRouteRules();
  const { state } = useLocation();
  const history = useHistory();
  const formRef = useRef<FormHandles>(null);
  const [loading, setLoading] = useState(false);
  const { cpf } = useAuth();

  const handleNext = useCallback(
    async (data: FormData) => {
      setLoading(true);

      const user = await IndividuoService.getIndividuoByCpf(state?.cpf);
      const codigo = user.items[0].codigoAutenticacao;
      if (data.verificationCode === codigo) {
        try {
          if (!state?.cpf) {
            return;
          }
          formRef.current?.setErrors({});

          await CodeSchema.validate(data, {
            abortEarly: false,
          });

          setLoading(false);

          history.push('/esqueci-minha-senha/senha', {
            cpf: state.cpf,
            codigoAutenticacao: data.verificationCode,
          });
        } catch (err) {
          setLoading(false);

          if (err instanceof Yup.ValidationError) {
            const errors = getValidationErrors(err);
            formRef.current?.setErrors(errors);
          }
        }
      } else {
        setLoading(false);
        toast.error('Código de verificação inválido.');
      }
    },
    [history, state],
  );

  const handleReSend = useCallback(() => {
    history.push('/esqueci-minha-senha/verificar', {
      cpf: state.cpf,
    });
  }, [history, state]);

  useEffect(() => {
    verifyRules({
      allowThesePreviousRoutes: ['/esqueci-minha-senha/verificar'],
      onError: () => {
        history.push('/esqueci-minha-senha');
      },
      onSuccess: () => {
        if (!state?.cpf) {
          history.push('/esqueci-minha-senha');
        }
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <Content>
        <h2>
          Código de autenticação enviado via {state?.metodo}, verifique suas
          mensagens
        </h2>

        <Form ref={formRef} onSubmit={handleNext}>
          <Input name="verificationCode" title="Inserir código" />

          <ResendCode>
            <p>Não recebei o código?</p>

            <button type="button" onClick={handleReSend}>
              re-enviar
            </button>
          </ResendCode>

          <Button type="submit" btnType="gray" loading={loading}>
            Próximo
          </Button>
        </Form>
      </Content>
    </Container>
  );
};

export default ConfirmCodeForgotPassword;
